import { create } from 'zustand';
import authFetch from '../utils/authFetch';

const useSettingsStore = create((set, get) => ({
  users: [],
  roles: [],
  loading: false,

  fetchUsers: async ({ includeInactive = false } = {}) => {
    set({ loading: true });
    try {
      const qs = includeInactive ? '?includeInactive=1' : '';
      const users = await authFetch(`/api/v1/users${qs}`);
      set({ users });
    } finally {
      set({ loading: false });
    }
  },

  fetchRoles: async () => {
    try {
      const roles = await authFetch('/api/v1/roles');
      set({ roles });
    } catch (err) {
      console.error('fetchRoles failed:', err);
    }
  },

  createUser: async ({ name, email, password, role_id }) => {
    const user = await authFetch('/api/v1/users', {
      method: 'POST',
      body: JSON.stringify({ name, email, password, role_id }),
    });
    await get().fetchUsers();
    return user;
  },

  updateUser: async (id, fields) => {
    const user = await authFetch(`/api/v1/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(fields),
    });
    set((s) => ({
      users: s.users.map((u) => (u.id === id ? { ...u, ...user } : u)),
    }));
    return user;
  },

  deleteUser: async (id) => {
    await authFetch(`/api/v1/users/${id}`, { method: 'DELETE' });
    set((s) => ({ users: s.users.filter((u) => u.id !== id) }));
  },

  updateMe: async (fields) => {
    return authFetch('/api/v1/users/me', {
      method: 'PUT',
      body: JSON.stringify(fields),
    });
  },

  changePassword: async (current_password, new_password) => {
    return authFetch('/api/v1/users/me/password', {
      method: 'PUT',
      body: JSON.stringify({ current_password, new_password }),
    });
  },

  uploadAvatar: async (file) => {
    const form = new FormData();
    form.append('avatar', file);
    const token = localStorage.getItem('token');
    const res = await fetch('/api/v1/users/me/avatar', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'Falha no upload');
    return data.data;
  },

  deleteAvatar: async () => {
    return authFetch('/api/v1/users/me/avatar', { method: 'DELETE' });
  },

  resetOrg: async (password) => {
    return authFetch('/api/v1/org/reset', {
      method: 'POST',
      body: JSON.stringify({ password }),
    });
  },
}));

export default useSettingsStore;
